import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';

const Documentations = () => {
    return (
        <div className="pochtabank-documentations">
            <FullWrapper caseName="pochtabank-documentationsCase">
                <div className="pochtabank-documentationsTitle">Документация</div>
                <div className="pochtabank-documentationsInner">
                    <div className="pochtabank-documentationsLeft">
                        <div>
                            Мы&nbsp;постарались не&nbsp;допустить ошибок предыдущего продукта
                            и&nbsp;поддерживаем основную документацию в&nbsp;идеологии docs-as-code,
                            используя open source инструмент docusaurus.
                        </div>
                        <div>
                            Новый сайт Почта Банка&nbsp;&mdash; уникальное в&nbsp;своем роде
                            техническое решение, в&nbsp;котором мы&nbsp;показали, что можно
                            запускать современный и&nbsp;качественный проект на&nbsp;базе
                            1С-Битрикс, интегрируя в&nbsp;него лучшие отраслевые решения
                            и&nbsp;передовые технологии. В&nbsp;настоящее время команда
                            &laquo;Вебпрактик&raquo; продолжает развитие сайта pochtabank.ru.
                        </div>
                    </div>
                    <div className="pochtabank-documentationsRight">
                        <div className="pochtabank-documentationsRightText">
                            Ведение документации
                        </div>
                        <div className="pochtabank-documentationsRightItem">
                            <img
                                src="/images/pic/new-pochtabank/docusaurus.jpg"
                                alt="icon"
                                className="pochtabank-documentationsRightIcon"
                            />
                            <div className="pochtabank-documentationsRightName">Docusaurus</div>
                        </div>
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default Documentations;
